<script setup>
const getYear = () => {
  return new Date().getFullYear();
};
const setYear = getYear();

const socialNetworks = [
  {
    name: "instagram",
    url: "https://www.instagram.com/plomerosatualcance/",
    icon: "fab fa-instagram",
  },
  {
    name: "whatsapp",
    url: "https://wa.link/znv6wi",
    icon: "fab fa-whatsapp",
  },
  {
    name: "tiktok",
    url: "https://www.tiktok.com/@plomerosatualcance",
    icon: "fab fa-tiktok",
  },
  {
    name: "facebook",
    url: "#",
    icon: "fab fa-facebook",
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/@plomerosatualcance-ws8oh",
    icon: "fab fa-youtube",
  },
];
</script>

<template>
  <footer>
    <div class="container-fluid bg-easy-dark">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3 py-4">
          <div>
            <img
              alt="plomeros911 logo"
              class="w-100 d-block mx-auto"
              src="../assets/logo_white.png"
            />
          </div>
          <div class="mt-3">
            <p class="text-justify text-white">
              Descubre la excelencia de Plomeros a tu alcance, tu equipo de
              fontaneros de confianza en Venezuela, Distrito Capital. Nos
              destacamos por ofrecer servicios a domicilio con garantía, siempre
              cercanos a nuestros usuarios para construir una relación basada en
              la confianza y el profesionalismo. Estamos disponibles las 24
              horas para atender tus necesidades con la máxima atención.
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3 py-4">
          <div>
            <h3 class="fw-bold text-size-30 text-white">Navegación</h3>
          </div>
          <div>
            <ul class="nav flex-column">
              <li class="nav-item">
                <router-link
                  to="/"
                  class="nav-link text-size-20 text-white ps-0 d-inline-block"
                  >Home</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/acerca-de-nosotros"
                  class="nav-link text-size-20 text-white ps-0 d-inline-block"
                  >Acerca de nosotros</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/galeria"
                  class="nav-link text-size-20 text-white ps-0 d-inline-block"
                  >Galeria</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/oportunidades"
                  class="nav-link text-size-20 text-white ps-0 d-inline-block"
                  >Oportunidades laborales</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/contacto"
                  class="nav-link text-size-20 text-white ps-0 d-inline-block"
                  >Contacto</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3 py-4">
          <div>
            <h3 class="fw-bold text-size-30 text-white">Encuentranos</h3>
          </div>
          <div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1649.3879799486056!2d-66.88782119064025!3d10.506349646326877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a593b4ed4a089%3A0x78e91bf3279d34b0!2sAv.%20Principal%20de%20Marip%C3%A9rez%2C%20Caracas%201050%2C%20Distrito%20Capital%2C%20Venezuela!5e0!3m2!1ses!2sdo!4v1704925075919!5m2!1ses!2sdo"
              class="w-100"
              height="300"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3 py-4">
          <div>
            <h3 class="fw-bold text-size-30 text-white">Contacto</h3>
          </div>
          <div>
            <ul class="nav flex-column">
              <li>
                <p class="text-white">
                  <i class="fas fa-map-marker-alt pe-2"></i>
                  Dirección: Urbanización Mariperez, Av Principal de Mariperez
                  Transversal 8 galpon 14, Caracas, Venezuela
                </p>
              </li>
              <li>
                <p class="text-white">
                  <i class="fas fa-phone-alt pe-2"></i>
                  Teléfonos:
                  <a
                    href="https://api.whatsapp.com/send?phone=584241284286"
                    class="text-white"
                    >+584241284286</a
                  >
                  /
                  <a
                    href="https://api.whatsapp.com/send?phone=584128775065"
                    class="text-white"
                    >+584128775065</a
                  >
                </p>
              </li>
              <li>
                <p class="text-white">
                  <i class="fas fa-envelope pe-2"></i>
                  Correo: support@plomerosatualcance.pro
                </p>
              </li>
              <li>
                <p class="text-white">
                  <i class="fas fa-building pe-2"></i>
                  Horario: Lunes-Viernes: 8 am - 5 pm
                </p>
              </li>
              <li>
                <div class="d-flex">
                  <div
                    v-for="(item, index) in socialNetworks"
                    :key="index"
                    class="pe-3"
                  >
                    <a :href="item.url" class="text-white d-block"
                      ><i :class="item.icon + ' icons-brands-size'"></i
                    ></a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row border-top border-4 border-white">
        <div class="col-12 ol-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <p class="text-white m-0 py-3 text-center">
            Copyright © {{ setYear }} plomerosatualcance.pro
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterComponent",
};
</script>
